import { PasswordRuleSettingsSchema } from '../../../../../tools/schemas/graph/password-rule-settings.schema';
import {
    createDirectorySetting,
    DirectorySetting,
    DirectorySettingValue,
    updateDirectorySetting,
} from 'projects/angular-clarity/src/app/stores/client/graph/directory-settings/actions';

const PASSWORD_RULE_SETTINGS_TEMPLATE_ID = '5cf42378-d67d-4f36-ba46-e8b86229381d';

export function Remediate(_tenant: string, current: DirectorySetting, schema: PasswordRuleSettingsSchema) {
    const allOf = schema?.properties?.values?.allOf ?? [];

    const values: DirectorySettingValue[] = allOf.map((item) => ({
        name: item.contains.properties.name.const,
        value: item.contains.properties.value.const,
    }));

    // BannedPasswordCheckOnPremisesMode is a required setting on Microsoft's side and the PATCH
    // is rejected if it is missing — even though it is useless (ignored) when
    // EnableBannedPasswordCheckOnPremises is false. Our schema omits it in that case to avoid this error
    // "The expected property 'BannedPasswordCheckOnPremisesMode' defined in template with SettingTemplateId '5cf42378-d67d-4f36-ba46-e8b86229381d' was not provided. paramName: BannedPasswordCheckOnPremisesMode, paramValue: System.String, objectType: Microsoft.Online.DirectoryServices.ObjectSettingTemplate"

    if (!values.some((v) => v.name === 'BannedPasswordCheckOnPremisesMode')) {
        values.push({
            name: 'BannedPasswordCheckOnPremisesMode',
            value: current?.values.find((res) => res.name === 'BannedPasswordCheckOnPremisesMode')?.value || 'Enforce',
        });
    }

    if (!current?.id) {
        // The setting does not exist until Password Protection is saved once — create it from the template.
        return createDirectorySetting({ _tenant, templateId: PASSWORD_RULE_SETTINGS_TEMPLATE_ID, values });
    }

    return updateDirectorySetting({ _tenant, id: current.id, values });
}
